// extracted by mini-css-extract-plugin
export var actionButton = "_gb-0";
export var fileInput = "_gb-2";
export var paperclip = "_gb-1";